// extracted by mini-css-extract-plugin
export default {"results":"Search_results__JfV5j","result":"Search_result__sESlC","match":"Search_match__u25sF"};